import { IonModal } from '@ionic/react'
import React, { useState } from 'react'
import { Input } from '@cps'
import './index.scss'

interface IModalProps {
  reject: () => void;
  resolve: (code: string) => void;
}

const PromoCodeExchange: React.FC<IModalProps> = (props: IModalProps) => {
  const { reject, resolve } = props
  const [code, setCode] = useState<string>('')
  const confirmExchange = () => {
    if (code) resolve && resolve(code)
  }
  return (

    <IonModal
      cssClass='promo-code-alert'
      isOpen
      onDidDismiss={reject}
    >
      <div className='modal-content'>
        <div className='back'><i data-cypid='mmgCloseExchangeCoupon' className='iconfont icon-close' onClick={reject}></i></div>
        <div className='title'>{i18n.t('mkt.coupon.exchangeCoupon')}</div>
        <div className='des-main'>
          <Input
            data-cypid='mmgCouponCodeInput'
            placeholder={i18n.t('mkt.coupon.plaPromoCode')}
            value={code || ''}
            onChange={(e) => {
              setCode(e.target.value)
            }}
            autoFocus
          />
        </div>
        <div data-cypid='mmgExchangeCoupon' className='modal-btn' onClick={confirmExchange}>
          <div>{i18n.t('newCart.confirm')}</div>
        </div>
      </div>
    </IonModal>
  )
}

export default PromoCodeExchange
